<template>
<div class="flex flex-col rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-100">
  <div v-if="hasCover" class="flex-shrink-0">
    <router-link :to="route">
      <responsive-image class="h-48 w-full object-cover" :media="article.media.cover" :sizes="['large', 'medium']" />
    </router-link>
  </div>
  <div class="flex-1 bg-white p-6 flex flex-col justify-between">
    <div class="flex-1">
      <p v-if="article.category && article.category.name" class="text-sm font-medium text-primary-darker">
        <router-link :to="categoryRoute" class="hover:underline">
          {{ article.category.name }}
        </router-link>
      </p>
      <router-link class="block mt-2" :to="route">
        <p class="text-xl font-bold">
          {{ article.title }}
        </p>
        <div class="mt-3 text-grey-darkest prose" v-html="article.intro"></div>
      </router-link>
    </div>
    <div class="mt-6 flex items-center">
      <div class="flex space-x-1 text-sm text-gray-500">
        <time :datetime="article.created_at.datetime">
          {{ article.created_at.datetime_at }}
        </time>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ResponsiveImage from '@/components/images/ResponsiveImage'

export default {
  props: {
    article: {
      required: true,
      type: Object,
    },
  },

  components: {
    ResponsiveImage,
  },

  computed: {
    hasCover() {
      return !!this.article.media && !!this.article.media.cover && !!this.article.media.cover.id
    },

    route() {
      return {
        name: 'blog-item',
        params: {
          shortId: this.article.short_id,
          slug: this.article.slug,
          article: this.article,
        }
      }
    },

    categoryRoute() {
      return {
        name: 'blog-list-category',
        params: {
          categoryShortId: this.article.category.short_id,
          categorySlug: this.article.category.slug,
        },
      }
    },
  },
}
</script>
